"use strict";

exports.__esModule = true;
var _DashboardCollection = require("./DashboardCollection");
Object.keys(_DashboardCollection).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DashboardCollection[key]) return;
  exports[key] = _DashboardCollection[key];
});
var _DashboardCollectionContext = require("./DashboardCollectionContext");
Object.keys(_DashboardCollectionContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DashboardCollectionContext[key]) return;
  exports[key] = _DashboardCollectionContext[key];
});